import { createContext } from 'react';

export interface FieldGroupListContextValue {
  depth: number;
  ancestorIndices: number[];
  isAncestorHighlighted: boolean;
}

const defaultContext = {
  depth: 1,
  ancestorIndices: [],
  isAncestorHighlighted: false
};

const FieldGroupListContext = createContext<FieldGroupListContextValue>(defaultContext);

export default FieldGroupListContext;
